import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import withDimensions from '../../hoc/with-dimensions';
import { inlineStylesIfRanking } from '../../internal/helpers';
import HeadCell from '../table-head-cell';
class RankableTableHeadCellComponent extends React.Component {
  render() {
    const {
      isRanking,
      refHeight,
      refWidth,
      ...restProps
    } = this.props;
    const inlineStyles = inlineStylesIfRanking(isRanking, refWidth);
    return /*#__PURE__*/React.createElement(HeadCell, _extends({
      inlineStyles: inlineStyles
    }, restProps));
  }
}
const RankableTableHeadCell = withDimensions(RankableTableHeadCellComponent);

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default RankableTableHeadCell;